export default class PageUtils {
    public static getPageParams = (url: string) => {
        let params: any = {};
        // noinspection JSUnresolvedVariable,JSUnresolvedFunction
        let parser = document.createElement('a');
        parser.href = url;
        // noinspection JSUnresolvedFunction
        let query = parser.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }
}